<template>
<div class="privacy-popup">
  <div class="popup-row">
    <div class="closer" @click="() => { $emit('close') }"></div>
    <div class="close-row">
      <img src="./img/close.svg" @click="() => { $emit('close') }" />
    </div>
    <!-- <img class="frame frame-size" src="./img/popup-frame.svg" /> -->
    <div class="frame">
      <div class="row title-row">
        <div class="magic-width title" v-if="SC.U === ENG">
          Personal Information <br /> Collection Statement

        </div>
        <div class="magic-width title" v-if="SC.U === CHI">
          收集個人資料聲明:
        </div>
      </div>

      <ol class="rule-list" v-if="SC.U === CHI">
        <li>資生堂集團及資生堂香港有限公司(「資生堂」或「本公司」)承諾會引用及遵守個人資料(私隱)條例﹝簡稱「條例」﹞的原則及規定，保障客戶個人資料的私隱。所有經此申請表收集所得的資料，只供以下用途：處理閣下之會員申請、提供會員服務及優惠、確認閣下身份、提供客戶服務、向閣下提供資生堂或其位於各地的集團公司推出有關香水和美容產品的特別優惠或新產品的信息、調查及研究閣下之需求，以作市場策劃及統計分析之用。</li>
        <li>本公司可轉移閣下之個人資料﹝包括閣下之姓名、地址、電話及電子郵件地址﹞予資生堂位於各地的集團公司作市場推廣之用，及本公司所聘用的第三方服務提供者，以協助本公司為閣下提供服務，包括輸入客戶資料、管理客戶資料庫、發送宣傳資訊、禮品換領信、電話推廣等。所有第三方服務提供者均已跟本公司簽訂栛議，確保資料得到保密。本公司會將個人資料保密儲存，只供授權資生堂或其位於各地的集團公司的員工及本公司所聘用的第三方服務提供者存取，並僅供以上所述之指定用途。本公司將不時修正或更新此私隱政策。</li>
        <li>閣下有權要求查閱、更正及刪除任何資生堂所保存有關閣下的個人資料。閣下如欲查閱、更改或刪除閣下的個人資料，或拒絕本公司使用閣下資料作市場推廣之用，請電郵至info@cledepeaubeaute.com.hk。</li>
      </ol>

      <ol class="rule-list" v-if="SC.U === ENG">
        <li>Shiseido Group and Shiseido Hong Kong Limited (“Shiseido”, “we” or “us”) are committed to apply and follow the principles and requirements of the Personal Data (Privacy) Ordinance , (“the Ordinance”) to safeguard the confidentiality of your personal information. Any of the information we collected from you on this form will be used in one of the following ways: processing your application for your membership scheme, provision of membership service and benefit, verifying your identity, providing you our customer service, notifying you of any promotion or new product information of Shiseido and its group of companies worldwide in relation to fragrance and beauty products and or study individual needs and market trends for research and statistical analysis.</li>
        <li>We may transfer your personal data (such as your name, mailing address, telephone number and email address) to Shiseido group of companies for direct marketing purpose and to trusted third party providing services such as data entry, management of customer database , dispatch of promotion materials, posting of redemption letters, telemarketing, etc. They are under an agreement of confidentiality with us to maintain the confidentiality of your personal data. Personal data held by Shiseido will be secured and can only be accessible by authorized employees of Shiseido and its group of companies worldwide and any third party service provides engaged by us in relation to the purposes as stated above. We reserve the right to make changes to this policy from time to time.</li>
        <li>You have the right to request access to, correction and deletion of any of your personal information held by us. If you would like to access, correct or delete your personal data, or do not want your personal data to be used for the purpose of direct marketing, you can send an email to info@cledepeaubeaute.com.hk.</li>
      </ol>
      <!-- <CTA class="cta" :text="'返回'" @action="$router.go(-1)" /> -->
    </div>
  </div>
</div>
</template>

<script>
import CTA from '@/components/DOM/CTA/CTA.vue'

import * as Text from '@/components/DOM/Text/Text.js'
export default {
  components: {
    CTA
  },
  data () {
    return {
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI
    }
  }
}
</script>

<style scoped>
.closer{
  position: absolute;
  top:0px;
  left:0px;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.title-row{
  margin-top: 10px;
}
.title{
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 30px;
  color: #CEBC9E;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 30px;
  margin-top: 60px;
}

.privacy-popup{
  width: 100%;
  height: 100%;
  background-color: rgba(6, 12, 38, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-row{
  transform: scale(0.9);
  height: 100%;
  width: 100%;
  position: relative;
}

.frame{
  position: absolute;
  top: calc(50% - 684px / 2);
  left: calc(50% - 600px / 2);
  width: 600px;
  height: 604px;
  border: #CEBC9E solid 1px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.rule-list{
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  letter-spacing: 1.8px;
  margin-top: 40px;
  width: 100%;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 12px;
}
.rule-list li{
  margin-bottom: 20px;
}
.cta{
  margin-top: 60px;
}
.close-row{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Privacy/PrivacyPopUp.vue